var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ico"},[_c('img',{class:_vm.classObject,attrs:{"src":_vm.uri}})])}
var staticRenderFns = []

export { render, staticRenderFns }